// i18n.js - Configuration for internationalization using i18next and react-i18next.
// Sets up resource loading for English and Spanish, with manual language management via global context.
// Fallbacks to English for missing keys; client-side only.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation resources (JSON files).
import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next.
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: 'en', // Initial language; overridden by global context on app load.
    fallbackLng: 'en', // Default to English if key missing or detection fails.
    debug: process.env.NODE_ENV === 'development', // Enable debug logs in dev mode.

    interpolation: {
      escapeValue: false, // React already escapes values.
    },
  });

export default i18n;